import React from "react";
import {
  DataGrid,
  Column,
  FormItem,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import uiInfo from "../ui-info";
import { criarNfseDs } from "../DataSources";
import PaginaToolbar from "../components/PaginaToolbar";
import { Button, ScrollView } from "devextreme-react";
import notify from "devextreme/ui/notify";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import apiAxios from "../api-axios";
import UserInfo from "../UserInfo";
import ShowError from "../AppServices";

export default class NfseGradeBox extends React.Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this._gridAtualizarNfse = React.createRef();
    this.nfseDs = criarNfseDs();
    this.state = {
      filtro: {
        numero: null,
        inscricao: null,
        tomadorNome: null,
        dataEmissao: null,
        dataDoServico: null,
        dataCompetencia: null,
        cancelada: 3,
        paga: 3,
        tipoData: 1,
      },
      filtroCorrente: [],
      nfseCancelamento: {},
      popupVerificarDados: false,
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);

    this.tipoDataOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "Data de Emissão", campo: "dataEmissao" },
        { id: 2, descricao: "Data do Serviço", campo: "dataDoServico" },
        { id: 3, descricao: "Competência", campo: "dataCompetencia" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.options = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NÃO" },
        { id: 3, descricao: "TODOS" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  async cancelar(e) {
    const registro = this.state.nfseCancelamento;

    if (this.state.motivoCancelamento == null)
      notify("Campo Motivo do Cancelamento precisa ser preenchido", "warning");
    else {
      try {
        const data = {
          id: registro.id,
          motivoCancelamento: this.state.motivoCancelamento,
        };

        const response = await apiAxios.post(
          `nota_fiscal_avulsa/cancelar/${UserInfo.getPrefeitura()}`,
          data
        );

        if (response.status === 200) {
          notify("NFSe Avulsa cancelada com sucesso!", "success");
        }

        this.setState({ ...this.state, popupVerificarDados: false });
        this._gridInstance.instance.refresh();
      } catch (error) {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      }
    }
  }

  popupVerificarDados(e) {
    const registro = e.row.data;

    return this.setState({
      ...this.state,
      nfseCancelamento: registro,
      popupVerificarDados: true,
    });
  }

  filtrar() {
    let filtro = [];
    let estado = this.state.filtro;

    if (estado.numero != null) {
      filtro.push(["numero", "=", estado.numero]);
    }

    if (estado.inscricao != null) {
      filtro.push(["cpbs.inscricao", "=", estado.inscricao]);
    }

    if (estado.tomadorNome != null) {
      filtro.push(["tomadorNome", "contains", estado.tomadorNome]);
    }

    if (estado.tomadorNome != null && estado.tomadorNome.trim() != "") {
      filtro.push(["tomadorNome", "contains", estado.tomadorNome]);
    }

    if (estado.cancelada != null && estado.cancelada != 3) {
      filtro.push(["cancelada", "=", estado.cancelada === 1]);
    }

    if (estado.paga != null && estado.paga != 3) {
      filtro.push(["paga", "=", estado.paga === 1]);
    }

    let campoData = this.tipoDataOpcoes.dataSource.filter(
      (p) => p.id == estado.tipoData
    )[0].campo;

    if (estado.dataInicial != null) {
      const data = estado.dataInicial;
      filtro.push([
        campoData,
        ">=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          0,
          0,
          0,
          0
        ),
      ]);
    }

    if (estado.dataFinal != null) {
      const data = estado.dataFinal;
      filtro.push([
        campoData,
        "<=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          23,
          5,
          59,
          999
        ),
      ]);
    }

    this._gridInstance.instance.filter(filtro.length > 0 ? filtro : null);
  }

  limparFiltro() {
    this.setState({
      filtro: {
        numero: null,
        inscricao: null,
        tomadorNome: null,
        dataEmissao: null,
        dataDoServico: null,
        dataCompetencia: null,
        cancelada: null,
        paga: null,
        tipoData: 1,
      },
    });
    this.filtrar();
  }

  cellRender(data) {
    if (data.value) return "SIM";
    else return "NÃO";
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="filtro-form"
            formData={this.state.filtro}
            colCount={15}
            labelLocation="top"
          >
            <GroupItem colCount={15} colSpan={15}>
              <SimpleItem
                colSpan={3}
                dataField="tipoData"
                editorType={"dxSelectBox"}
                editorOptions={this.tipoDataOpcoes}
              >
                <Label text="Tipo Data" />
              </SimpleItem>
              <SimpleItem
                colSpan={2}
                dataField="dataInicial"
                editorType="dxDateBox"
                editorOptions={{ displayFormat: "dd/MM/yyyy" }}
              >
                <Label text="Data Inicial" />
              </SimpleItem>

              <SimpleItem
                colSpan={2}
                dataField="dataFinal"
                editorType="dxDateBox"
                editorOptions={{ displayFormat: "dd/MM/yyyy" }}
              >
                <Label text="Data Final" />
              </SimpleItem>

              <SimpleItem
                colSpan={3}
                dataField="cancelada"
                editorType="dxSelectBox"
                editorOptions={this.options}
              >
                <Label text="Cancelada" />
              </SimpleItem>

              <SimpleItem
                colSpan={3}
                dataField="paga"
                editorType="dxSelectBox"
                editorOptions={this.options}
              >
                <Label text="Paga" />
              </SimpleItem>

              <SimpleItem colSpan={2} dataField="numero">
                <Label text="Número" />
              </SimpleItem>

              <SimpleItem colSpan={3} dataField="cpbs.inscricao">
                <Label text="Inscrição" />
              </SimpleItem>

              <SimpleItem colSpan={12} dataField="tomadorNome">
                <Label text="Nome" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <PaginaToolbar
          titulo="Lista de NFSe"
          ocultarNovo={true}
          printData={() => this.state.filtro}
        >
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.nfseDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            focusedRowEnabled={false}
            allowColumnReordering={true}
          >
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                {
                  hint: "Cancelar",
                  icon: "remove",
                  onClick: (e) => {
                    this.popupVerificarDados(e);
                  },
                },
                {
                  hint: "Imprimir NF",
                  icon: "exportpdf",
                  onClick: (e) => notify("Imprimindo NFSe!", "success"),
                },
              ]}
            />
            <Column
              dataField={"numero"}
              visible={true}
              caption={"Número"}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"cpbs.inscricao"}
              caption={"Inscrição"}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"tomadorNome"}
              caption={"Nome"}
              visible={true}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"dataEmissao"}
              caption={"Emissão"}
              dataType={"date"}
              width={100}
            />
            <Column
              dataField={"descricaoDoServico"}
              caption={"Serviço Prestado"}
              showInColumnChooser={false}
            />
            <Column
              dataField={"cancelada"}
              visible={true}
              showInColumnChooser={false}
              cellRender={this.cellRender}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"paga"}
              visible={true}
              showInColumnChooser={false}
              cellRender={this.cellRender}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"dataCompetencia"}
              caption={"Competência"}
              visible={true}
              showInColumnChooser={false}
              dataType={"date"}
            >
              <FormItem visible={true}></FormItem>
            </Column>

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

            <Pager
              showInfo={true}
              showNavigationButtons={true}
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>

        <Popup
          visible={this.state.popupVerificarDados}
          onHiding={() => this.setState({ popupVerificarDados: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={600}
          height={500}
          title="Verificar Dados Para Cancelamento"
        >
          <ScrollView showScrollbar="always">
            <form>
              <Form formData={this.state.nfseCancelamento}>
                <SimpleItem
                  dataField={"numero"}
                  render={() => (
                    <span>
                      {this.state.nfseCancelamento &&
                        this.state.nfseCancelamento.numero}
                    </span>
                  )}
                >
                  <Label text="Número" />
                </SimpleItem>

                <SimpleItem
                  dataField={"tomadorNome"}
                  render={() => (
                    <span>{this.state.nfseCancelamento.tomadorNome}</span>
                  )}
                >
                  <Label text="Nome do Tomador" />
                </SimpleItem>

                <SimpleItem
                  dataField={"tomadorCpfCnpj"}
                  render={() => (
                    <span>{this.state.nfseCancelamento.tomadorCpfCnpj}</span>
                  )}
                >
                  <Label text="Documento do Tomador" />
                </SimpleItem>

                <SimpleItem
                  dataField={"descricaoDoServico"}
                  editorType={"dxTextArea"}
                  editorOptions={{ readOnly: true, height: "90px" }}
                >
                  <Label text="Serviço Prestado" />
                </SimpleItem>

                <SimpleItem
                  dataField={"dataCompetencia"}
                  render={() => (
                    <span>{this.state.nfseCancelamento.dataCompetencia}</span>
                  )}
                >
                  <Label text="Competência" />
                </SimpleItem>
              </Form>
              <br />
              <br />
              <Form formData={this.state} colCount={1} labelLocation="top">
                <SimpleItem
                  dataField={"motivoCancelamento"}
                  editorType={"dxTextArea"}
                  editorOptions={{
                    placeholder: "Digite aqui...",
                    height: "100px",
                  }}
                >
                  <Label text="Motivo do Cancelamento" />
                </SimpleItem>
              </Form>
            </form>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Confirmar",
              type: "success",
              width: 150,
              onClick: () => {
                this.cancelar();
              },
            }}
          />
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Cancelar",
              type: "default",
              width: 150,
              onClick: () => {
                this.setState({ popupVerificarDados: false });
                return notify("Operação cancelada!", "warning");
              },
            }}
          />
        </Popup>
      </div>
    );
  }
}
